import React from 'react';
import FullWrapper from '../../layouts-components__common-cases/full-wrapper';

import './style.sass';
import ScrollAnimation from '../../../../../../../core/ScrollAnimation';

const UkassaProcess = () => {
    return (
        <div className="ukassa-process">
            <ScrollAnimation
                delay={0}
                animateIn="fadeIn"
                offset={300}
                animateOnce={true}
                duration={1}
            >
                <FullWrapper bigPaddings isMargin={false}>
                    <span className="ukassa-process__title">Ход работ</span>
                    <span className="ukassa-process__subtitle">
                        Мы разработали план по переезду с учетом ребрендинга и отсутствия
                        редиректов.
                    </span>
                    <span className="ukassa-process__text">
                        По причине смены домена, объективно просели все показатели, но благодаря
                        детальному анализу и своевременным алертам, мы заметили часть ключевых фраз,
                        которые совсем не показывали динамику. Это стало нашей основной точкой
                        развития.
                    </span>

                    <div className="ukassa-process__list">
                        <div className="ukassa-process__item">
                            <span className="ukassa-process__item-text">
                                Описание ТЗ с требованиями к переносу
                            </span>
                            <div className="ukassa-process__item-wrap-progress">
                                <div className="ukassa-process__item-progress ukassa-process__item-progress--green seven-day">
                                    7 дней
                                </div>
                            </div>
                        </div>

                        <div className="ukassa-process__item">
                            <span className="ukassa-process__item-text">
                                Сайт должен сразу работать на https, без www. С альтернативных
                                версий должны быть настроены 301 редиректы.
                            </span>
                            <div className="ukassa-process__item-wrap-progress">
                                <div className="ukassa-process__item-progress ukassa-process__item-progress--green seven-day">
                                    7 дней
                                </div>
                            </div>
                        </div>

                        <div className="ukassa-process__item">
                            <span className="ukassa-process__item-text">
                                Проведение всестороннего аудита сайта на DEV, оперативное
                                исправление проблем.
                            </span>
                            <div className="ukassa-process__item-wrap-progress">
                                <div className="ukassa-process__item-progress ukassa-process__item-progress--green two-day">
                                    2 дня
                                </div>
                            </div>
                        </div>

                        <div className="ukassa-process__item">
                            <span className="ukassa-process__item-text">
                                Подготовка Robots.txt и Sitemap.xml для нового сайта.
                            </span>
                            <div className="ukassa-process__item-wrap-progress">
                                <div className="ukassa-process__item-progress ukassa-process__item-progress--green one-day">
                                    1 день
                                </div>
                            </div>
                        </div>

                        <div className="ukassa-process__item">
                            <span className="ukassa-process__item-text">
                                Корректировка URL-страниц с упоминанием старого бренда
                            </span>
                            <div className="ukassa-process__item-wrap-progress">
                                <div className="ukassa-process__item-progress ukassa-process__item-progress--green one-day">
                                    1 день
                                </div>
                            </div>
                        </div>

                        <div className="ukassa-process__item">
                            <span className="ukassa-process__item-text">
                                Рекомендации по созданию на новом сайте страницы с подробностями
                                ребрендинга, анонсировать ее на главной
                            </span>
                            <div className="ukassa-process__item-wrap-progress">
                                <div className="ukassa-process__item-progress ukassa-process__item-progress--green one-day">
                                    1 день
                                </div>
                            </div>
                        </div>

                        <div className="ukassa-process__item">
                            <span className="ukassa-process__item-text">
                                Корректный перенос счетчиков аналитики и целей
                            </span>
                            <div className="ukassa-process__item-wrap-progress">
                                <div className="ukassa-process__item-progress ukassa-process__item-progress--green one-day">
                                    1 день
                                </div>
                            </div>
                        </div>

                        <div className="ukassa-process__item">
                            <span className="ukassa-process__item-text ukassa-process__item-text--bold">
                                Релиз
                            </span>
                            <div className="ukassa-process__item-wrap-progress">
                                <div className="ukassa-process__item-progress ukassa-process__item-progress--green one-day">
                                    1 день
                                </div>
                            </div>
                        </div>

                        <div className="ukassa-process__item">
                            <span className="ukassa-process__item-text">
                                Оперативная смена домена в контактах во всех социальных сетях
                            </span>
                            <div className="ukassa-process__item-wrap-progress">
                                <div className="ukassa-process__item-progress ukassa-process__item-progress--blue one-day">
                                    1 день
                                </div>
                            </div>
                        </div>

                        <div className="ukassa-process__item">
                            <span className="ukassa-process__item-text">
                                Переклейка доменов в вебмастерах
                            </span>
                            <div className="ukassa-process__item-wrap-progress">
                                <div className="ukassa-process__item-progress ukassa-process__item-progress--blue one-day">
                                    1 день
                                </div>
                            </div>
                        </div>

                        <div className="ukassa-process__item">
                            <span className="ukassa-process__item-text">
                                Массовая замена во всех текстах и метатегах старого бренда на новый.
                            </span>
                            <div className="ukassa-process__item-wrap-progress">
                                <div className="ukassa-process__item-progress ukassa-process__item-progress--blue one-day">
                                    1 день
                                </div>
                            </div>
                        </div>

                        <div className="ukassa-process__item">
                            <span className="ukassa-process__item-text">
                                Проверка нового сайта после релиза.
                            </span>
                            <div className="ukassa-process__item-wrap-progress">
                                <div className="ukassa-process__item-progress ukassa-process__item-progress--blue one-day">
                                    1 день
                                </div>
                            </div>
                        </div>
                    </div>
                </FullWrapper>
            </ScrollAnimation>
        </div>
    );
};

export default UkassaProcess;
